var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',[_c('el-aside',{staticClass:"med-left-menu",attrs:{"width":"200px"}},[_c('app-navmenuleftmedecin',{attrs:{"idmed":_vm.idMed}})],1),_c('el-container',[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }